import { forwardRef, type PropsWithChildren } from "react";

import { Circle, type CircleBadgeProps, type CircleProps } from "@eisox/design-system";
import { ValveIcon } from "@eisox/icons";

interface ValveProps extends CircleProps, PropsWithChildren {
  error?: CircleBadgeProps["variant"];
}

const Valve = forwardRef<HTMLDivElement, ValveProps>(
  ({ size = 20, backgroundColor = "blue", color = "white", children, error, style, ...props }, ref) => {
    const fontSize = Circle.useCircleFontSize(size, children);
    return (
      <Circle.Root
        {...props}
        ref={ref}
        size={size}
        backgroundColor={backgroundColor}
        color={color}
        style={{ fontSize, ...style }}
      >
        {children ?? <ValveIcon />}
        {error && <Circle.Badge variant={error} />}
      </Circle.Root>
    );
  },
);

Valve.displayName = "Valve";

export default Valve;
export { Valve };
export type { ValveProps };
